export default __webpack_public_path__ + "static/media/male-2.1bd3327c.jpg";